import CheckboxSetting from 'hb-builder/components/common/SettingsLibrary/CommonSettings/CheckboxSetting';
import HorizontalAlignment from 'hb-builder/components/common/SettingsLibrary/CommonSettings/HorizontalAlignment';
import NumberSetting from 'hb-builder/components/common/SettingsLibrary/CommonSettings/NumberSetting';
import type { ComponentSettingsTab } from 'hb-builder/types/settings';
import type { EmailImageItemAttributes } from 'hb-react/backoffice/types/builder/itemAttributes/emailImageItemAttributess';

const Style = ({
  defaultAttributes,
  item,
  onChange,
}: ComponentSettingsTab<EmailImageItemAttributes>) => {
  const settingProps = { defaultAttributes, item, onChange };

  return (
    <>
      <HorizontalAlignment title={__('Alignment')} {...settingProps} />
      <CheckboxSetting
        settingKey="imageFullWidth"
        title={__('Full width')}
        {...settingProps}
      />
      <NumberSetting
        settingKey="imageRadius"
        title={__('Rounded corner')}
        {...settingProps}
      />
    </>
  );
};

export default Style;
